<template>
  <div>
    <v-col cols="3">
      <v-btn
        block
        height="42px"
        color="#1db954"
        style="color: black"
        class="download-btn"
        @click="openModal('create')"
      >
        <v-icon>mdi mdi-plus-thick</v-icon>
        Neu
      </v-btn>
    </v-col>
    <v-data-table
      :key="vegetationUpdateKey"
      :headers="headers"
      :search="performSearch"
      :items="vegetations"
      :loading="isLoading"
      :footer-props="{
        'items-per-page-text': 'Zeilen pro Seite',
      }"
    >
      <template v-slot:item.actions="{ item }">
        <div class="button-container">
          <v-icon
            small
            class="edit green--text icon-style"
            @click="openModal('update', item)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
            small
            class="delete green--text icon-style"
            @click="openDeleteModal('delete', item)"
          >
            mdi-delete
          </v-icon>
        </div>
      </template>
    </v-data-table>
    <create-vegetation
      :vegetation="{ abbreviation: '', name: '' }"
      :visible="dialogType === 'create'"
      :id="null"
      @close="closeModal"
      @addItem="addItem"
      v-on:updated-table="updatedList"
    />
    <update-vegetation
      :key="vegetationUpdateKey"
      :vegetation="selectedVegetation"
      :visible="dialogType === 'update'"
      :id="selectedVegetation.id"
      @close="closeModal"
      v-on:updated-table="updatedList"
      @updateItem="updateItem"
    />
    <delete-vegetation
      :visible="dialogType === 'delete'"
      :vegetation="selectedVegetation"
      :item-list="itemList"
      v-on:updated-table="updatedList"
      @close="closeDeleteModal"
    ></delete-vegetation>
  </div>
</template>

<script>
import CreateVegetation from "./CreateVegetation";
import UpdateVegetation from "./UpdateVegetation";
import DeleteVegetation from "./DeleteVegetation";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    CreateVegetation,
    UpdateVegetation,
    DeleteVegetation,
  },
  data() {
    return {
      headers: [
        { text: "Abkürzung", value: "abbreviation" },
        { text: "Beschreibung", value: "name" },

        { text: "", value: "actions", sortable: false },
      ],
      itemList: [],
      vegetationUpdateKey: null,
      vegetationList: [],
      isLoading: false,
      dialogType: "",
      selectedVegetation: {},
      localSearch: null,
      showDeleteModal: false,
    };
  },
  computed: {
    ...mapGetters(["getSearchquery", "vegetations"]),

    performSearch() {
      return this.getSearchquery;
    },
  },
  mounted() {
    this.localSearch = this.getSearchquery;
  },
  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions(["fetchVegetations", "createVegetation", "updateVegetation"]),
    editVegetation(vegetation) {
      this.selectedVegetation = { ...vegetation };
      this.dialogType = "update";
    },
    updatedList(boolean) {
      if (boolean) {
        this.fetchData();
      }
    },

    openModal(type, vegetation) {
      this.dialogType = type;
      if (type === "update") {
        this.selectedVegetation = { ...vegetation };
      }
    },
    openDeleteModal(type, vegetation) {
      this.dialogType = type;
      if (type === "delete") {
        this.selectedVegetation = { ...vegetation };
      }
    },
    closeModal() {
      this.dialogType = "";
      this.selectedVegetation = {};
    },
    closeDeleteModal() {
      this.showDeleteModal = false;
      this.dialogType = "";
      this.selectedVegetation = {};
    },
    async addItem(newItem) {
      this.isLoading = true;
      await this.createVegetation(newItem);
      this.closeModal();
    },
    async updateItem(item) {
      this.isLoading = true;
      await this.updateVegetation(item);
      this.vegetationUpdateKey += 1;
      this.closeModal();
    },
    fetchData() {
      this.isLoading = true;
      this.fetchVegetations()
        .then(() => {
          //    this.$store.commit("setVegetationTypeResults", response.data);
          this.vegetations = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
    handleSearch(query) {
      this.getSearchquery = query;
    },
  },
};
</script>
<style lang="scss" scoped>
.icon-style {
  border: 1px solid #494949;
  padding: 3px;
  border-radius: 5px;
  width: 42px;
  height: 42px;
  margin-left: -60px !important;
}

.button-container {
  display: flex;
  align-items: center;
}
.button-container .delete {
  position: absolute;
  right: 15px;
}
.button-container .edit {
  position: absolute;
  right: 67px;
}
.add-button {
  outline: none !important;
  margin-bottom: 10px;
  width: 220px;
}
</style>
